import { Component, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { MenuController } from '@ionic/angular';
import { AlertService } from '../../../services/alert.service';
//import { BrandService } from '../../services/brand.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
//import { MenuConfig } from '../../types/MenuConfig';
//import { VersionService } from '../../services/version.service';
import { Capacitor } from '@capacitor/core';
import { CountryISO, SearchCountryField } from 'ngx-intl-tel-input';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { ToastService } from '../../../services/toast.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss', '../authentication.scss']
})
export class LoginPage {

  title = 'Login';
  loginForm: FormGroup;

  appVersion: string;
  buildVersion: string = "1";
  environment: string = "dev";
  //theme: string;

  phoneNumber: string = '';

  @ViewChild('phoneNumberInput', { static: true })
  phoneNumberEl!: ElementRef;

  errorMessage!: string;

  displayEnv: boolean;

  ng2TelCustomOptions = {
    initialCountry: 'au',
    dropdownContainer: document.body,
    utilsScript: 'utils.js',
    customPlaceholder: (selectedCountryPlaceholder: any, selectedCountryData: any) => {
      return 'e.g. ' + selectedCountryPlaceholder;
    },
  };

  CountryIso = CountryISO;
  SearchCountryField = SearchCountryField;

  constructor(
    private router: Router,
    private menuCtrl: MenuController,
    private docTitle: Title,
    private formBuilder: FormBuilder,
    public alertService: AlertService,
    //private versionService: VersionService,
    //public brandService: BrandService,
    private amplifyAppService: AuthService,
    private toastService: ToastService,
    private renderer: Renderer2,
    private activatedRoute: ActivatedRoute,
    private analyticsService: AnalyticsService,
  ) {
    this.menuCtrl.enable(false, 'left');
    this.menuCtrl.enable(false, 'right');
    this.docTitle.setTitle(this.title);
    this.loginForm = this.formBuilder.group({
      phone: ['', [Validators.required]],
    });
    this.appVersion = "3.0"; // this.versionService.getAppVersion();
    // this.registeredPhoneNumber = this.navParams.get('registeredPhoneNumber');
    this.displayEnv = false;
    this.analyticsService.tagRoute('unauthenticated/login');
  }

  ionViewDidEnter() {
    this.loginForm.updateValueAndValidity();
    // this.loginForm.controls['phone'].setValue(this.registeredPhoneNumber);
    // This is to update the country code if it exists in the input
    this.phoneNumberEl.nativeElement.dispatchEvent(new Event('keyup'));
    const phone = this.renderer.selectRootElement('input[ng2telinput]');
    this.focusOnPhoneNumber(phone, 1000);
  }

  verifyLogin() {
    this.analyticsService.tagButtonPress('login_page', 'verifylogin');
    const intlNumber = this.phoneNumber;
    if (Capacitor.isNativePlatform() && this.isDemoUser()) {
      this.router.navigate(['unauthenticated', 'verifylogin'], { queryParams: { phone: intlNumber }});
    } else if (intlNumber) {
      this.sendCode(intlNumber);
    }
  }

  goToContactUs() {
    this.analyticsService.tagButtonPress('login_page', 'contactus');
    this.router.navigate(['unauthenticated', 'contactus']);
  }

  async sendCode(phoneNumber: string) {
    try {
      if (Capacitor.isNativePlatform()) {
        await this.amplifyAppService.sendForgotPasswordCode(phoneNumber);
      } else {
        this.amplifyAppService.sendCustomAuthSmsCode(phoneNumber);
      }

      // this.toastService.show(`We sent a SMS to ${phoneNumber} with a code, please enter it here.`);

      this.router.navigate(['unauthenticated', 'verifylogin'], { queryParams: { phone: phoneNumber }});
    } catch (error) {
      this.handleError(error);
    }
  }

  handleError(error: any) {
    console.error('Login: Code', error);
    if (this.amplifyAppService.isInvalidParameterException(error)) {
      // this is an educated guess that the user is in an UNCONFIRMED state
      // and needs a signUpCode instead of a forgotPasswordCode
      this.sendSignUpCode(this.phoneNumber);
    } else if (this.amplifyAppService.isUserNotFoundException(error)) {
      this.handleUserNotFoundAlert();
    } else {
      this.alertService.showAmplifyAuthError(error);
    }
  }

  handleUserNotFoundAlert() {
    this.alertService.confirm(
      `This mobile number is not registered`,
      `Would you like to register?`,
      `Register`,
      () => { this.goToRegister(); });
  }

  sendSignUpCode(phone: string) {
    this.amplifyAppService.resendSignUpCode(phone)
      .then(() => {
        this.toastService.show(`We sent a SMS to ${phone} with a code, please enter it here.`);
        this.router.navigate(['../VerifySignUpPage'], { queryParams: { phone: phone }, relativeTo: this.activatedRoute });
      })
      .catch((error: any) => {
        this.alertService.showAmplifyAuthError(error);
        console.error('sendSignUpCode:', error);
      });
  }


  setPhoneNumber($event: any) {
    if ($event) {
      this.phoneNumber = $event.e164Number ?? $event.internationalNumber ?? '';
      this.setErrorMessage(this.phoneNumber);
    }
  }

  setErrorMessage(phoneNumber: string) {
    if (!Boolean(phoneNumber)) {
      this.errorMessage = 'Mobile number is required';
      this.loginForm.controls['phone'].setErrors({ 'required': true });
    } else if (!this.loginForm.valid) {
      this.errorMessage = 'Mobile number is not valid';
      this.loginForm.controls['phone'].setErrors({ 'invalid': true });
    }
  }

  goToRegister() {
    this.router.navigate(['unauthenticated', 'siteCodeEntry']);
  }

  isDemoUser() {
    return (this.phoneNumber ?? '').endsWith('000000');
  }

  toggleEnvText() {
    if (this.environment !== 'prod') {
      this.displayEnv = !this.displayEnv;
    }
  }

  /*changeTheme(theme: string) {
    this.brandService.set(theme);
  }*/

  focusOnPhoneNumber(phoneNumber: any, timeout?: number) {
    setTimeout(() => {
      if (phoneNumber) {
        phoneNumber.focus();
      }
    }, timeout || 200);
  }

}
